/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Section_AboutInputs */

const de_commons_footer_section_about = /** @type {(inputs: Commons_Footer_Section_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr über waipu.tv`)
};

/** @type {(inputs: Commons_Footer_Section_AboutInputs) => LocalizedString} */
const en_commons_footer_section_about = de_commons_footer_section_about;

/**

* @param {Commons_Footer_Section_AboutInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_section_about = /** @type {((inputs?: Commons_Footer_Section_AboutInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Section_AboutInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_section_about(inputs)
	return en_commons_footer_section_about(inputs)
});